/* eslint-disable no-use-before-define, no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { COMMONSTATUS_REDUCER_NAME } from './Constants';

const initialState = {
  isSave: false,
  resizeTrigger: false,
  deleteResizeMode: false,
};

export const commonStatusSlice = createSlice({
  name: COMMONSTATUS_REDUCER_NAME,
  initialState,
  reducers: {
    setEditorSave: (state, { payload: { saveBoolean } }) => {
      state.isSave = saveBoolean;
    },

    setTriggerResize: (state, { payload: { resizeTriggerBoolean } }) => {
      state.resizeTrigger = resizeTriggerBoolean;
    },
  },
});

const { setEditorSave, setTriggerResize, setDeleteTriggerResize } = commonStatusSlice.actions;

export { setEditorSave, setTriggerResize, setDeleteTriggerResize };

export default commonStatusSlice.reducer;
